import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { StepProps } from './types';
import { FormTextInput } from '../../../shared/inputs/FormTextInput';
import { FormBooleanSegmentedField, FormTextArea } from '../FormControls';
import { RenovationsField } from '../ListFields';
import type { SchemaRealEstatesForm } from '~/features/leadDetails/schemas/realEstates.schema';

const FIELD_LABEL_CLASS_NAME = 'h-8 w-[360px] shrink-0 justify-start whitespace-nowrap';

export const RenovationsStep: React.FC<StepProps> = ({ disabled, realEstateIndex }) => {
    const { t } = useTranslation();
    const { control } = useFormContext<SchemaRealEstatesForm>();
    const prefix = `immobilien.${realEstateIndex}.baubeschreibung.sanierungen` as const;

    return (
        <div className="space-y-4">
            <RenovationsField realEstateIndex={realEstateIndex} disabled={disabled} />
            <FormBooleanSegmentedField
                name={`${prefix}.teilungserklaerungVorhanden`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.FIELDS.DECLARATION_OF_DIVISION')}
                labelClassName={FIELD_LABEL_CLASS_NAME}
                disabled={disabled}
            />
            <FormTextInput
                control={control}
                id={`${prefix}.alsEigentuemerImGrundbuchEingetragen`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.FIELDS.LAND_REGISTER_OWNER')}
                labelClassName={FIELD_LABEL_CLASS_NAME}
                disabled={disabled}
            />
            <FormTextArea
                name={`${prefix}.besonderheitenImGrundbuch`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.FIELDS.LAND_REGISTER_DETAILS')}
                labelClassName={FIELD_LABEL_CLASS_NAME}
                disabled={disabled}
            />
        </div>
    );
};
